import { getInicioEFimDoMes } from '~/graphql/pre-defined-filters/utils';

export default function () {
  const [inicioDoMes, finalDoMes] = getInicioEFimDoMes();
  return {
    where: {
      and: [
        {
          dataEncerramento: {
            gte: inicioDoMes,
          },
        },
        {
          dataEncerramento: {
            lte: finalDoMes,
          },
        },
      ],
    },
  };
}
